import { createSelector } from "reselect"
import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("servicequestionmultichoice", "sqmcorder")

export const serviceQuestionMultiChoiceReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_SERVICEQUESTIONMULTICHOICE":
			return [...state, action.response[0]]

		case "UPDATE_SERVICEQUESTIONMULTICHOICE": {
			const updatedState = state.map((object) => {
				if (object.servicequestionmultichoiceid === action.id) {
					return { ...object, ...action.json }
				}
				return object
			})

			return [...updatedState]
		}

		case "DELETE_SERVICEQUESTIONMULTICHOICE":
			return state.filter((object) => object.servicequestionmultichoiceid !== action.id)

		default:
			return state
	}
}

export const selectQuestionMultiChoicesByQuestionId = createSelector(
	(state, questionId) => state.serviceQuestionMultiChoiceReducer,
	(_, questionId) => questionId,
	(choices, questionId) => {
		return choices.filter((choice) => questionId === choice.servicequestionid)
	}
)
